import React from "react";
import AppLayout from "./layout";
import { useHistory } from "react-router-dom";

export default function SignIn() {
  const history = useHistory();

  return <AppLayout title={"Blank"}></AppLayout>;
}
